import { IEvent } from "@quest/adapter-interface";
import { BaseViewGame } from "../BaseViewGame";
import { detectDeviceEnvironmentConstants, dispatcher, ingenuity } from "@quest/base-core";
import { SlotConstantsBehavior, SlotEventConstantsBehavior } from "@quest/murka-games-behavior-leopard";
import { gameConstants } from "../Constants/gameConstants";

export class SelectionScreenView extends BaseViewGame {
  constructor(json: any) {
    super(json);
  }

  /**
   * Overrided to handle resizeing
   */

  protected resize(evt: IEvent): void {
    super.resize(evt);
    if (ingenuity.deviceEnv.getOrientation() === detectDeviceEnvironmentConstants.constants.ORIENTATION.PORTRAIT) {
      this.pivot.set(
        ingenuity.configData.width * SlotConstantsBehavior.HALF_CONVERTER,
        ingenuity.configData.height * SlotConstantsBehavior.HALF_CONVERTER
      );
      this.scale.set(ingenuity.deviceEnv.getPortraitMaxReelScale());
      this.x = innerWidth * SlotConstantsBehavior.HALF_CONVERTER;
      this.y = innerHeight * SlotConstantsBehavior.HALF_CONVERTER + SlotConstantsBehavior.ADD_IN_Y;
    }
    if (ingenuity.deviceEnv.getOrientation() !== detectDeviceEnvironmentConstants.constants.ORIENTATION.PORTRAIT) {
          this.scale.set(ingenuity.deviceEnv.getLandcapeMaxReelScale())
          this.y = (innerHeight * SlotConstantsBehavior.HALF_CONVERTER) + ((gameConstants.REEL_BOTTOM_SPACE/2)*this.scale.x);
          if(!ingenuity.deviceEnv.isDesktop) {
            this.y = (innerHeight * SlotConstantsBehavior.HALF_CONVERTER) + ((gameConstants.REEL_BOTTOM_SPACE_LANDSCAPE/2)*this.scale.x);
          }
        }else{
          dispatcher.fireEvent(SlotEventConstantsBehavior.SHOW_TOP_GAME_LOGO);
        }
  }
}
